<template>
  <div>
    <div id="aaa"></div>
    <van-nav-bar
      fixed
      title="客户列表"
      left-arrow
      @click-left="onClickLeft"
    />

    <van-field
      v-model="message"
      rows="1"
      autosize
      label="搜索"
      type="textarea"
      placeholder="客户名称/客户编号"
    />

    <van-radio-group v-model="radio">
      <van-cell-group>
        <van-cell title="石城县中医院" label="客户编号:88888" clickable @click="radio = '1'">
          <van-radio slot="right-icon" name="1" />
        </van-cell>
        <van-cell title="石城县中医院" label="客户编号:88888" clickable @click="radio = '2'">
          <van-radio slot="right-icon" name="2" />
        </van-cell>
      </van-cell-group>
    </van-radio-group>
  </div>
</template>

<script>
import  { NavBar,  RadioGroup, Radio ,Field , Cell, CellGroup } from 'vant'
export default {
  components:{
    [NavBar.name]:NavBar,
    [RadioGroup.name]:RadioGroup,
    [Radio.name]:Radio,
    [Field.name]:Field,
    [Cell.name]:Cell,
    [CellGroup.name]:CellGroup
  },
  data(){
    return{
      radio: '1',
      message:''
    }
  },
   methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    
  }
}
</script>

<style scoped lang="less">
.van-nav-bar{
  background: #456;
  color:white;
}
.van-nav-bar__title{
  font-weight: 800;
  color:white
}
#aaa{
  width:100vw;
  height:46px;
}
</style>